import React from "react";
import { ReactComponent as FolderIcon } from "../../../../assets/Icons/Setting/Profile/FolderIcon.svg";
import SchoolLogoIm from "../../../../assets/Images/Logo/DemoSchoolLogo.png";
import Image from "../../../Universal/Image.component";
const DocumentFolder = ({ folderName, onDoubleClick }) => {
  return (
    <button
      type="button"
      className="adminProfileDocumentFolder"
      onDoubleClick={onDoubleClick}
    >
      <div className="folderIcon">
        <FolderIcon fill="white" />
      </div>

      <div
        className="flex-row align-center justify-center g-05 pb-1 pt-1 pl-1 pr-1"
        style={{ backgroundColor: "#fff3d9", height: "40%" }}
      >
        <Image src={SchoolLogoIm} style={{ width: "2rem", height: "2rem" }} />
        <h3 className="t-11 poppins-medium weight-500 text-align-left">
          Elementary School Business and social science
        </h3>
      </div>

      <div className="flex-1 flex-col align-center justify-center">
        <h3 className="weight-500 poppins-semiBold t-15 color-textWhite">
          {folderName}
        </h3>
      </div>
    </button>
  );
};

export default DocumentFolder;
